import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const TermsOfServicePage = () => {
  return (
    <div className="relative min-h-screen bg-background-primary text-text-primary antialiased flex flex-col font-sans overflow-hidden">
      <Helmet>
        <title>Terms of Service | Just One Week Games</title>
        <meta
          name="description"
          content="Terms of Service for Knight Survivor and Just One Week Games."
        />
        <meta name="robots" content="noindex" />
      </Helmet>

      {/* Background Video */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-background-primary/90 z-10" />
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          poster="/video-poster.png"
          className="w-full h-full object-cover opacity-30"
        >
          <source src="/bg-optimized.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="relative z-10 flex flex-col min-h-screen">
        <main className="container mx-auto px-4 py-12 flex-grow flex flex-col items-center">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-8 text-center"
          >
            <Link to="/">
              <img
                src="/JOW Games Pixelated.png"
                alt="Just One Week Games"
                className="h-24 mx-auto object-contain hover:opacity-80 transition-opacity"
              />
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="w-full max-w-4xl bg-background-card/80 backdrop-blur-md p-8 rounded-2xl border border-accent-secondary/20 shadow-xl"
          >
            <h1 className="text-3xl font-bold mb-8 text-accent-primary text-center">
              Terms of Service
            </h1>

            <div className="prose prose-invert max-w-none text-text-secondary">
              <p>Last updated: {new Date().toLocaleDateString()}</p>

              <h2>1. Agreement to Terms</h2>
              <p>
                By accessing or playing our games (including Knight Survivor),
                you agree to be bound by these Terms of Service and our Privacy
                Policy.
              </p>

              <h2>2. Authentication and Accounts</h2>
              <p>
                We use Discord for authentication. We do not store passwords. By
                logging in, you authorize us to access your Discord username and
                ID to manage your game session and progress. You are responsible
                for maintaining the security of your Discord account.
              </p>

              <h2>3. Acceptable Use</h2>
              <p>
                You agree not to use our services for any unlawful purpose or to
                violate any laws in your jurisdiction. Cheating, hacking, or
                exploiting bugs is strictly prohibited.
              </p>

              <h2>4. Intellectual Property</h2>
              <p>
                The game, including all content, graphics, and code, is the
                property of Just One Week Games and is protected by copyright
                laws.
              </p>

              <h2>5. Termination</h2>
              <p>
                We reserve the right to terminate or suspend your account
                immediately, without prior notice or liability, for any reason
                whatsoever, including without limitation if you breach the
                Terms.
              </p>
            </div>
          </motion.div>
        </main>

        <footer className="container mx-auto px-4 py-6 flex flex-col md:flex-row items-center justify-between text-text-secondary text-sm">
          <div className="order-2 md:order-1 mt-4 md:mt-0 text-center md:text-left">
            <p>
              &copy; {new Date().getFullYear()} Just One Week Games. All rights
              reserved.
            </p>
            <div className="mt-2 flex gap-4 justify-center md:justify-start">
              <Link
                to="/terms"
                className="hover:text-accent-primary transition-colors"
              >
                Terms of Service
              </Link>
              <Link
                to="/privacy"
                className="hover:text-accent-primary transition-colors"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
